import { Editor } from '@tiptap/core';
import { JSONContent } from '@tiptap/react';
import { useGuideCmsContext } from '../GuideCmsContext';

export type CitationIndices = Map<string, number>;

const STORAGE_KEY = 'citationIndices';

export const computeCitationIndices = (root: JSONContent): CitationIndices => {
  const indices: CitationIndices = new Map();
  const walk = (node: JSONContent) => {
    if (node.type === 'citationLink') {
      const citationId = node.attrs?.citationId as string | undefined;
      if (citationId && !indices.has(citationId)) {
        indices.set(citationId, indices.size + 1);
      }
      return;
    }
    for (const child of node.content ?? []) {
      walk(child);
    }
  };
  walk(root);
  return indices;
};

export const useCitationIndex = (citationId: string, editor?: Editor): number | undefined => {
  const { editor: editorFromContext } = useGuideCmsContext();
  return ((editor ?? editorFromContext)?.storage[STORAGE_KEY] as CitationIndices | undefined)?.get(citationId);
};

export const useCitationIndices = (editor?: Editor): CitationIndices => {
  const { editor: editorFromContext } = useGuideCmsContext();
  return ((editor ?? editorFromContext)?.storage[STORAGE_KEY] as CitationIndices | undefined) ?? new Map<string, number>();
};

export const useUpdateCitationIndicesOnEditor = () => {
  const context = useGuideCmsContext();
  return (editor: Editor) => {
    if (editor.isDestroyed) return;
    editor.storage[STORAGE_KEY] = computeCitationIndices(editor.getJSON());
    context.forceRefreshEditors();
  };
};
